import React from "react"
import ScrollLTR from "../../../../../lms-shared/UI/ScrollLTR";
import classes from './QuestionList.module.css';
import PlusIcon from '../../../../../../assests/lesson/reflection/plus.png';
import ReflectionView from "../../../../../lms-shared/Reflection/ReflectionActions/ReflectionView/ReflectionView";

const QuestionList = ({ reflection, currentIndex, addReflection, setCurrentIndex }) => {

    return (
        <div className={classes.QuestionsList}>
            <ScrollLTR dropStyle={{ height: '100%', maxHeight: '800px', width: '100%' }}>
                <div className={classes.Questions}>
                    {reflection.length > 0 && reflection.map((question, index) =>
                        <div key={index} className={classes.Question}>
                            <div className={classes.Num}>{index + 1}</div>
                            <div className={`${index === currentIndex && classes.CurrentQuestion} ${classes.QuestionDiv}`} onClick={() => setCurrentIndex(index)}>
                                <ReflectionView question={question} edit={false} />
                            </div>
                        </div>
                    )}
                    <div className={classes.AddQuestion} onClick={(reflection[reflection.length - 1]?.id || reflection.length === 0) ? addReflection : null}>
                        <img className={!reflection[reflection.length - 1]?.id && reflection.length !== 0 ? classes.Disable : null} src={PlusIcon} />
                    </div>
                </div>
            </ScrollLTR>
        </div>
    )
}

export default QuestionList;